const state = {
  listings: JSON.parse(sessionStorage.getItem('listings')) || [],
  listings_error: null,
};

const mutations = {
  listings(state) {
    state.listings_error = null;
  },
  listingsFailed(state, payload) {
    state.listings_error = payload.error;
  },
  listingsSuccess(state, payload) {
    state.listings_error = null;
    state.listings = payload;

    sessionStorage.setItem('listings', JSON.stringify(state.listings));
  },
};

const actions = {
  listings: ({ commit }) => commit('listings'),
};

const getters = {
  listingsError: (state) => state.listings_error,
  listings: (state) => state.listings,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
